import styled from 'styled-components';

import { floorGameColor as color } from '@pkg/primitives';

export const StyledThumbnail = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background-color: ${color.blackberryDark};
`;
